import { render } from "./ModalButton.vue?vue&type=template&id=5f82dd40&scoped=true"
import script from "./ModalButton.vue?vue&type=script&lang=js"
export * from "./ModalButton.vue?vue&type=script&lang=js"

import "./ModalButton.vue?vue&type=style&index=0&id=5f82dd40&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f82dd40"]])

export default __exports__